<!-- <div class="top_row_heading" *ngIf="lndUserType">
  <div
    class="col-1 header"
    (click)="allLink.home()"
    style="max-width: fit-content; cursor: pointer"
  >
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
  </div>
  <p>HR Manager</p>
  <span class="nav_style" (click)="allLink.openNav()">&#9776; </span>
</div> -->
<span *ngIf="lndUserType">
<app-header-global></app-header-global>
</span>
<!-- <app-side-overlay-menu></app-side-overlay-menu> -->


<div class="row row_nav">
  <div [ngClass]="sidebarCollapsed ? 'col-sm-1 custom_col_1' : 'col-sm-2'">
      <app-side-overlay-menu></app-side-overlay-menu>
  </div>
  <div [ngClass]="sidebarCollapsed ? 'col-sm-11 custom_col-sm-11' : 'col-sm-10'">
    <router-outlet></router-outlet>
  </div>
</div>




 <!-- <ul> -->
      <!-- <li>
        <a routerLink="employelist" routerLinkActive="active">Employee List</a>
      </li>
      <li>
        <a routerLink="companylist" routerLinkActive="active"
          >Company List</a
        >
      </li>
      <li>
        <a routerLink="businesslist" routerLinkActive="active"
          >Business List</a
        >
      </li>
      <li>
        <a routerLink="departmentlist" routerLinkActive="active"
          >Department List</a
        >
      </li>
      <li>
        <a routerLink="holidaylist" routerLinkActive="active"
          >List of Holiday</a
        >
      </li> -->
     
      <!-- <li>
        <a routerLink="leavesreport" routerLinkActive="active">Leaves Report</a>
      </li> -->
    <!-- </ul> -->